import { action } from 'mobx';
import { IConnectionAttendeeDTO } from '../../../api/connections.dao';
import { AttendeeMeetingConnection } from './attendee-meeting.connection.entity';

export class PresenterOrHostMeetingAttendee extends AttendeeMeetingConnection {
    public static create(attendeeProps: IConnectionAttendeeDTO): AttendeeMeetingConnection {
        return new PresenterOrHostMeetingAttendee(attendeeProps);
    }

    @action.bound
    public toDTO() {
        const _dto = super.toDTO();
        return _dto;
    }

    constructor({ ...rest }: IConnectionAttendeeDTO) {
        super(rest);
    }
}
